var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbroadImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 139,
    viewBox: "0 0 160 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45_2483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.0494 123.099C108.557 123.099 134.099 97.5569 134.099 66.0494C134.099 34.5419 108.557 9 77.0494 9C45.5419 9 20 34.5419 20 66.0494C20 97.5569 45.5419 123.099 77.0494 123.099Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_45_2483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.073 29.9566C129.795 29.9566 131.112 31.2735 131.112 32.9956V99.5483C131.112 101.27 129.795 102.587 128.073 102.587H25.9643C24.2422 102.587 22.9253 101.27 22.9253 99.5483V32.9956C22.9253 31.2735 24.2422 29.9566 25.9643 29.9566H128.073Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M131.112 32.9956V39.1747H22.9258V32.9956C22.9258 31.2735 24.2426 29.9566 25.9647 29.9566H128.073C129.795 29.9566 131.112 31.2735 131.112 32.9956Z",
    fill: "url(#paint0_linear_45_2483)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M27.7876 35.8319C28.5149 35.8319 29.1045 35.2423 29.1045 34.515C29.1045 33.7877 28.5149 33.1982 27.7876 33.1982C27.0603 33.1982 26.4707 33.7877 26.4707 34.515C26.4707 35.2423 27.0603 35.8319 27.7876 35.8319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.5361 35.8319C32.2634 35.8319 32.853 35.2423 32.853 34.515C32.853 33.7877 32.2634 33.1982 31.5361 33.1982C30.8088 33.1982 30.2192 33.7877 30.2192 34.515C30.2192 35.2423 30.8088 35.8319 31.5361 35.8319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.2841 35.8319C36.0114 35.8319 36.601 35.2423 36.601 34.515C36.601 33.7877 36.0114 33.1982 35.2841 33.1982C34.5568 33.1982 33.9673 33.7877 33.9673 34.515C33.9673 35.2423 34.5568 35.8319 35.2841 35.8319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.691 67.1329H87.8577C87.2499 67.1329 86.6421 66.6264 86.6421 65.9174V54.0655C86.6421 53.4577 87.1486 52.8499 87.8577 52.8499H121.691C122.299 52.8499 122.907 53.3564 122.907 54.0655V66.0187C122.805 66.6264 122.299 67.1329 121.691 67.1329Z",
    fill: "#E6ECF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.805 86.9873C122.805 87.5951 122.299 88.2029 121.59 88.2029H87.8577C87.2499 88.2029 86.6421 87.6964 86.6421 86.9873V75.0342C86.6421 74.4264 87.1486 73.8186 87.8577 73.8186H121.691C122.299 73.8186 122.907 74.3251 122.907 75.0342V86.9873H122.805Z",
    fill: "#E6ECF5"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_45_2483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.634 48.1902H56.4552C55.5436 48.1902 54.8345 47.4811 54.8345 46.5695V13.5464C54.8345 12.6347 55.5436 11.9256 56.4552 11.9256H101.634C102.546 11.9256 103.255 12.6347 103.255 13.5464V46.6708C103.255 47.4811 102.546 48.1902 101.634 48.1902Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.6549 21.245H70.9408C70.5356 21.245 70.1304 20.8398 70.1304 20.4347C70.1304 20.0295 70.5356 19.6243 70.9408 19.6243H87.6549C88.0601 19.6243 88.4653 20.0295 88.4653 20.4347C88.4653 20.8398 88.0601 21.245 87.6549 21.245Z",
    fill: "url(#paint1_linear_45_2483)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7924 26.1073H61.6212C61.3173 26.1073 61.1147 25.9047 61.1147 25.6008C61.1147 25.2969 61.3173 25.0943 61.6212 25.0943H82.7924C83.0963 25.0943 83.299 25.2969 83.299 25.6008C83.299 25.9047 83.0963 26.1073 82.7924 26.1073Z",
    fill: "url(#paint2_linear_45_2483)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6706 26.1073H86.0343C85.7304 26.1073 85.5278 25.9047 85.5278 25.6008C85.5278 25.2969 85.7304 25.0943 86.0343 25.0943H96.6706C96.9745 25.0943 97.1771 25.2969 97.1771 25.6008C97.1771 25.9047 96.9745 26.1073 96.6706 26.1073Z",
    fill: "url(#paint3_linear_45_2483)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6702 29.8553H82.7924H81.8807H61.6212C61.3173 29.8553 61.1147 30.0579 61.1147 30.3618C61.1147 30.6657 61.3173 30.8683 61.6212 30.8683H81.8807H82.7924H96.6702C96.9742 30.8683 97.1768 30.6657 97.1768 30.3618C97.1768 30.1592 96.9742 29.8553 96.6702 29.8553Z",
    fill: "url(#paint4_linear_45_2483)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6702 34.7176H82.7924H81.8807H61.6212C61.3173 34.7176 61.1147 34.9202 61.1147 35.2241C61.1147 35.528 61.3173 35.7306 61.6212 35.7306H81.8807H82.7924H96.6702C96.9742 35.7306 97.1768 35.528 97.1768 35.2241C97.1768 34.9202 96.9742 34.7176 96.6702 34.7176Z",
    fill: "url(#paint5_linear_45_2483)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6702 39.4786H82.7924H81.8807H61.6212C61.3173 39.4786 61.1147 39.6812 61.1147 39.9851C61.1147 40.289 61.3173 40.4916 61.6212 40.4916H81.8807H82.7924H96.6702C96.9742 40.4916 97.1768 40.289 97.1768 39.9851C97.1768 39.6812 96.9742 39.4786 96.6702 39.4786Z",
    fill: "url(#paint6_linear_45_2483)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_45_2483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.278 105.93H103.457C102.546 105.93 101.735 105.221 101.735 104.208V93.2678C101.735 92.3561 102.444 91.5457 103.457 91.5457H136.278C137.19 91.5457 138 92.2548 138 93.2678V104.208C137.899 105.221 137.19 105.93 136.278 105.93Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M131.72 97.2184H108.421C108.016 97.2184 107.813 96.9145 107.813 96.6106C107.813 96.2054 108.117 96.0028 108.421 96.0028H131.618C132.023 96.0028 132.226 96.3067 132.226 96.6106C132.327 96.9145 132.023 97.2184 131.72 97.2184Z",
    fill: "url(#paint7_linear_45_2483)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.616 101.979H108.421C108.016 101.979 107.813 101.676 107.813 101.372C107.813 100.966 108.117 100.764 108.421 100.764H123.616C124.021 100.764 124.224 101.068 124.224 101.372C124.224 101.676 123.92 101.979 123.616 101.979Z",
    fill: "url(#paint8_linear_45_2483)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.018 58.2187H93.3275C93.0236 58.2187 92.7197 57.9148 92.7197 57.6109C92.7197 57.307 93.0236 57.0031 93.3275 57.0031H116.018C116.322 57.0031 116.626 57.307 116.626 57.6109C116.626 57.9148 116.322 58.2187 116.018 58.2187Z",
    fill: "url(#paint9_linear_45_2483)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.117 62.8784H93.3275C93.0236 62.8784 92.7197 62.5746 92.7197 62.2707C92.7197 61.9668 93.0236 61.6629 93.3275 61.6629H108.117C108.421 61.6629 108.725 61.9668 108.725 62.2707C108.725 62.5746 108.421 62.8784 108.117 62.8784Z",
    fill: "url(#paint10_linear_45_2483)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.018 79.1874H93.3275C93.0236 79.1874 92.7197 78.8835 92.7197 78.5796C92.7197 78.2757 93.0236 77.9718 93.3275 77.9718H116.018C116.322 77.9718 116.626 78.2757 116.626 78.5796C116.626 78.9848 116.322 79.1874 116.018 79.1874Z",
    fill: "url(#paint11_linear_45_2483)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.117 83.9484H93.3275C93.0236 83.9484 92.7197 83.6445 92.7197 83.3406C92.7197 83.0367 93.0236 82.7328 93.3275 82.7328H108.117C108.421 82.7328 108.725 83.0367 108.725 83.3406C108.725 83.6445 108.421 83.9484 108.117 83.9484Z",
    fill: "url(#paint12_linear_45_2483)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3224 88.4055H31.7384C30.6241 88.4055 29.7124 87.4938 29.7124 86.3795V54.9772C29.7124 53.8629 30.6241 52.9512 31.7384 52.9512H77.3224C78.4367 52.9512 79.3484 53.8629 79.3484 54.9772V86.3795C79.3484 87.4938 78.4367 88.4055 77.3224 88.4055Z",
    fill: "#E6ECF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3409 80.8082H38.9307L47.1358 71.4888L55.3409 80.8082Z",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0162 80.8082H45.3125L57.1643 67.3356L69.0162 80.8082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1099 68.0447C46.8442 68.0447 48.2502 66.6387 48.2502 64.9044C48.2502 63.1701 46.8442 61.7642 45.1099 61.7642C43.3756 61.7642 41.9697 63.1701 41.9697 64.9044C41.9697 66.6387 43.3756 68.0447 45.1099 68.0447Z",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M77.3224 112.413C88.3436 112.413 97.2781 103.479 97.2781 92.4574C97.2781 81.4362 88.3436 72.5017 77.3224 72.5017C66.3012 72.5017 57.3667 81.4362 57.3667 92.4574C57.3667 103.479 66.3012 112.413 77.3224 112.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.205 116.769L102.951 120.922L90.7954 108.868L94.9486 104.714L107.205 116.769Z",
    fill: "#526DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1149 75.0342C51.9981 84.151 51.9981 98.8392 61.1149 107.855C70.2318 116.87 84.9199 116.972 93.9355 107.855C103.052 98.7379 103.052 84.0497 93.9355 75.0342C84.8186 66.0187 70.1305 65.9174 61.1149 75.0342ZM90.1874 104.208C83.1979 111.198 71.7512 111.198 64.7617 104.208C57.7721 97.2184 57.7721 85.7718 64.7617 78.7822C71.7512 71.7927 83.1979 71.7927 90.1874 78.7822C97.2783 85.7718 97.2783 97.1171 90.1874 104.208Z",
    fill: "url(#paint13_linear_45_2483)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.79 127.506C111.865 129.431 108.826 129.431 107.003 127.506L94.6444 115.249C93.834 114.54 93.834 113.223 94.6444 112.514L98.6963 108.462C99.4054 107.753 100.621 107.753 101.431 108.462L113.79 120.72C115.613 122.644 115.613 125.683 113.79 127.506Z",
    fill: "url(#paint14_linear_45_2483)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7279 103.803C76.8162 103.803 76.1072 103.094 76.1072 102.182C76.1072 101.27 76.9175 100.46 77.8292 100.46C78.7409 100.46 79.5513 101.169 79.5513 102.081C79.45 103.094 78.7409 103.803 77.8292 103.803H77.7279ZM77.8292 98.6366C76.9175 98.6366 76.2085 97.9275 76.1072 97.0158C76.1072 96.9145 76.1072 96.9145 76.1072 96.8132V93.4704C76.1072 91.7483 77.2214 90.2289 78.8422 89.6211C80.1591 89.2159 80.9695 87.899 80.8682 86.5821C80.7669 85.0627 79.5513 83.7458 77.9305 83.6445H77.7279C76.4111 83.6445 75.1955 84.5562 74.7903 85.8731C74.5877 86.5822 73.8786 86.9873 73.1695 86.9873C72.9669 86.9873 72.7643 86.9873 72.5617 86.886C71.7514 86.5822 71.2449 85.7718 71.4475 84.8601C72.2578 82.125 74.7903 80.0991 77.7279 80.0991C77.8292 80.0991 78.0318 80.0991 78.1331 80.0991C79.8552 80.2004 81.4759 80.9095 82.5902 82.2263C83.7045 83.5432 84.3123 85.164 84.211 86.886C84.1097 89.4185 82.3876 91.7483 80.0578 92.66H79.9565H79.8552C79.6526 92.7613 79.45 92.9639 79.5513 93.2678V96.5093C79.5513 97.0158 79.45 97.421 79.1461 97.7249C78.8422 98.0288 78.437 98.2314 77.9305 98.3327L77.8292 98.6366Z",
    fill: "url(#paint15_linear_45_2483)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_45_2483",
    x: 0.925293,
    y: 18.9566,
    width: 152.187,
    height: 116.63,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_45_2483"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_45_2483",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_45_2483",
    x: 32.8345,
    y: 0.925598,
    width: 92.4204,
    height: 80.2646,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_45_2483"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_45_2483",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_45_2483",
    x: 79.7349,
    y: 80.5457,
    width: 80.2651,
    height: 58.3843,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_45_2483"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_45_2483",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45_2483",
    x1: 22.7521,
    y1: 34.5468,
    x2: 93.64,
    y2: 34.5468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2539D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_45_2483",
    x1: 70.1081,
    y1: 20.4109,
    x2: 88.469,
    y2: 20.4109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_45_2483",
    x1: 61.0952,
    y1: 25.6036,
    x2: 83.3071,
    y2: 25.6036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F3F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_45_2483",
    x1: 85.4992,
    y1: 25.6036,
    x2: 97.2277,
    y2: 25.6036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F3F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_45_2483",
    x1: 61.0952,
    y1: 30.4178,
    x2: 97.2275,
    y2: 30.4178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F3F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_45_2483",
    x1: 61.0952,
    y1: 35.2319,
    x2: 97.2275,
    y2: 35.2319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F3F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_45_2483",
    x1: 61.0952,
    y1: 40.0461,
    x2: 97.2275,
    y2: 40.0461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F3F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_45_2483",
    x1: 107.789,
    y1: 96.5416,
    x2: 132.328,
    y2: 96.5416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6ECF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_45_2483",
    x1: 107.789,
    y1: 101.367,
    x2: 124.253,
    y2: 101.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6ECF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_45_2483",
    x1: 92.6786,
    y1: 57.5607,
    x2: 116.613,
    y2: 57.5607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6ECF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_45_2483",
    x1: 92.6786,
    y1: 62.2675,
    x2: 108.737,
    y2: 62.2675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6ECF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_45_2483",
    x1: 92.6786,
    y1: 78.6011,
    x2: 116.613,
    y2: 78.6011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6ECF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_45_2483",
    x1: 92.6786,
    y1: 83.3079,
    x2: 108.737,
    y2: 83.3079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6ECF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_45_2483",
    x1: 54.2799,
    y1: 91.4496,
    x2: 100.743,
    y2: 91.4496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_45_2483",
    x1: 94.0079,
    y1: 118.444,
    x2: 115.178,
    y2: 118.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_45_2483",
    x1: 77.9007,
    y1: 81.5762,
    x2: 77.9007,
    y2: 101.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_2483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 139,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbroadImg);
export default __webpack_public_path__ + "static/media/abroadImg.40d563834c3e2a7477514c5f8ee39bc9.svg";
export { ForwardRef as ReactComponent };